/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/ConditionsEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ConditionsEditorTestIds = {
  btnAddCondition: "btn-add-condition",
  conditionsEmptyHint: "conditions-empty-hint",
  conditionsEmptyInfo: "conditions-empty-info",
  badge: (opt_code: string) => `badge-${opt_code}`,
  badgePrefix: () => "badge-" as TestIdPrefix,
  optionConditionField: (f: string) => `option-condition-field-${f}`,
  optionConditionFieldPrefix: () => "option-condition-field-" as TestIdPrefix,
  optionConditionOperator: (op: string) => `option-condition-operator-${op}`,
  optionConditionOperatorPrefix: () => "option-condition-operator-" as TestIdPrefix,
  optionConditionValue: (opt_code: string) => `option-condition-value-${opt_code}`,
  optionConditionValuePrefix: () => "option-condition-value-" as TestIdPrefix,
  badgesConditionValue: (index: number) => `badges-condition-value-${index}`,
  badgesConditionValuePrefix: () => "badges-condition-value-" as TestIdPrefix,
  btnRemoveCondition: (index: number) => `btn-remove-condition-${index}`,
  btnRemoveConditionPrefix: () => "btn-remove-condition-" as TestIdPrefix,
  selectConditionField: (index: number) => `select-condition-field-${index}`,
  selectConditionFieldPrefix: () => "select-condition-field-" as TestIdPrefix,
  selectConditionOperator: (index: number) => `select-condition-operator-${index}`,
  selectConditionOperatorPrefix: () => "select-condition-operator-" as TestIdPrefix,
  selectConditionValue: (index: number) => `select-condition-value-${index}`,
  selectConditionValuePrefix: () => "select-condition-value-" as TestIdPrefix
} as const;
